'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPasteHtmlPlugin;

var _slate = require('slate');

/**
 * Define a set of node renderers.
 *
 * @type {Object}
 */
/**
 * Tags to blocks.
 *
 * @type {Object}
 */

var BLOCK_TAGS = {
  div: 'div',
  p: 'paragraph',
  li: 'list_item',
  ul: 'ul_list',
  ol: 'ol_list',
  blockquote: 'quote',
  pre: 'code',
  h1: 'heading-one',
  h2: 'heading-two',
  h3: 'heading-three',
  h4: 'heading-four',
  h5: 'heading-five',
  h6: 'heading-six',
  table: 'table',
  // thead: 'thead',
  // tbody: 'tbody',
  tr: 'table_row',
  td: 'table_cell'
};

/**
 * Tags to marks.
 *
 * @type {Object}
 */

var MARK_TAGS = {
  b: 'bold',
  strong: 'bold',
  em: 'italic',
  i: 'italic',
  u: 'underline',
  s: 'strikethrough',
  code: 'code'
};

var RULES = [
// Logger
{
  deserialize: function deserialize(el) {
    console.log(el);
  }
},
// Handle default tags
{
  deserialize: function deserialize(el, next) {
    if (!el.name) return undefined;
    var block = BLOCK_TAGS[el.name];
    if (!block) return undefined;
    return {
      kind: 'block',
      type: block,
      nodes: next(el.children)
    };
  }
},
// Handle img tag
{
  deserialize: function deserialize(el) {
    if (el.name !== 'img') return undefined;
    return {
      kind: 'block',
      type: 'image',
      isVoid: true,
      data: {
        src: el.attribs.src
      }
    };
  }
},
// Handle marks tag
{
  deserialize: function deserialize(el, next) {
    if (!el.name) return undefined;

    var mark = MARK_TAGS[el.name];
    if (!mark) return undefined;
    return {
      kind: 'mark',
      type: mark,
      nodes: next(el.children)
    };
  }
}, {
  // Handle a tag
  deserialize: function deserialize(el, next) {
    if (el.name !== 'a') return undefined;
    return {
      kind: 'inline',
      type: 'link',
      nodes: next(el.children),
      data: {
        href: el.attribs.href
      }
    };
  }
}, {
  // TODO Handle not use text
  deserialize: function deserialize(el) {
    if (el.type !== 'text') return;
    if (el.data.startsWith('\n')) {
      console.log(el.data);
      return;
    }
  }
}];

var serializer = new _slate.Html({ rules: RULES });

function createPasteHtmlPlugin() {
  var onPaste = function onPaste(e, data, state) {
    if (data.type !== 'html') return null;

    var _serializer$deseriali = serializer.deserialize(data.html);

    var document = _serializer$deseriali.document;


    return state.transform().insertFragment(document).apply();
  };

  return {
    onPaste: onPaste
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/slate-plugins-paste-html/lib/index.js
// module id = 693
// module chunks = 0